import { render, staticRenderFns } from "./Ranson.vue?vue&type=template&id=a27fd174&scoped=true&"
import script from "./Ranson.vue?vue&type=script&lang=js&"
export * from "./Ranson.vue?vue&type=script&lang=js&"
import style0 from "./Ranson.vue?vue&type=style&index=0&id=a27fd174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27fd174",
  null
  
)

export default component.exports